<template>
  <div>
    <input-qr-scan-model
      v-model="code"
      ref="codeRef"
      label="Tên"
      @keyupEnter="scanInput"
    ></input-qr-scan-model>

    <div>
      <v-simple-table class="table-padding-2 table-h-36 mb-2">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader" class="text-center">Tên</th>
              <th role="columnheader" class="text-center">QR</th>
              <th role="columnheader" class="text-center">Loại tài sản</th>
              <th role="columnheader" class="text-center">Tài sản</th>
              <th role="columnheader" class="text-center">T. Thái</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in items"
              :key="`i_${index}_${item.id}`"
              class="text-center"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.asset_type_name }}</td>
              <td>{{ item.asset_name }}</td>
              <td>{{ item.status_txt }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <div>
      <v-simple-table class="table-padding-2 table-h-36 mb-2">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader" class="text-center">Tracking ID</th>
              <th role="columnheader" class="text-center">Updated At</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(orderItem, orderIndex) in orderItems"
              :key="`i_${orderIndex}_${orderItem.id}`"
              class="text-center"
            >
              <td>
                <span
                  class="fs-14px font-weight-medium text-decoration-underline primary--text text-right"
                  @click="showOrderDialog(orderItem)"
                >
                  {{ orderItem.tracking_id }}
                </span>
              </td>
              <td>{{ formatDateTime(orderItem.updated_at) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <v-dialog v-model="orderDialog" max-width="400px">
      <DetailDialog
        v-if="orderDialog"
        :order="order"
        :is-show-exchange="true"
        @close="hideorderDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import { ASSET_UID_STATUS_OPTIONS } from "@/libs/const";

export default {
  name: "GetAssetByName",
  components: {
    DetailDialog: () => import("@/components/exchange/DetailDialog"),
  },
  data: () => ({
    items: [],
    orderItems: [],
    code: null,
    orderDialog: false,
    order: {},
  }),
  mounted() {},
  methods: {
    showorderDialog() {
      this.orderDialog = true;
    },

    hideorderDialog() {
      this.orderDialog = false;
    },

    async showOrderDialog(item) {
      await this.getDetail({ id_order: item.id });
      this.orderDialog = true;
    },

    async getDetail({ id_order }) {
      const { data } = await httpClient.post("/order/v1/get-detail", {
        id_order,
      });
      this.order = { ...data };
    },

    async scanInput() {
      if (!this.code) {
        return false;
      }
      const { data } = await httpClient.post("/asset/v1/get-items", {
        code: this.code,
      });
      this.items = [...data.items].map((r) => ({
        ...r,
        status_txt: [...ASSET_UID_STATUS_OPTIONS].find(
          (s) => s.value == r.status
        ).text,
      }));
      this.orderItems = [...data.order_items];
    },
  },
};
</script>
